import React, {useState} from "react"
import {ItemKeyEvents, Event} from "../../../dtos/eventResponse"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import * as Order from "../../../dtos/orderResponse"
import ItemDetails from "./ItemDetails"
import KeyEventsStatistics from "./KeyEventsStatistics"
import EventAccordionDetails from "./EventAccordionDetails"
import ItemTimeline from "./ItemTimeline"
import {
	getItemDeliveryDate,
	getItemStatus,
	getOrderItemTimeLine,
} from "../../../services/order/eventHelper"
import {Button, Collapse, Grid, IconButton} from "@mui/material"
import {makeStyles} from "tss-react/mui"

interface ItemEventAccordionProps {
	itemKeyEvents: ItemKeyEvents | undefined
	lineItem: Order.LineItem
	expandedPanel: string | boolean
	updateExpandedPanel: (expanded: string) => void
	orderCreationDate: string
	isOrderLegacy: boolean
	locale: string
}

const useStyles = makeStyles()({
	expandButton: {
		fontSize: "13px",
		fontStyle: "normal",
		fontWeight: 500,
		lineHeight: "22px",
		letterSpacing: "0.46px",
		textTransform: "uppercase",
		pointerEvents: "auto",
	},
	summary: {
		pointerEvents: "none",
	},
	expandOpen: {
		transform: "rotate(180deg)",
	},
})

export default function ItemEventAccordion(props: ItemEventAccordionProps) {
	const {classes} = useStyles()
	const [expanded, setExpanded] = useState<boolean>(props.expandedPanel === props.lineItem.id)
	const getWarningsCount = (): number => {
		if (
			props.itemKeyEvents &&
			props.itemKeyEvents.events &&
			props.itemKeyEvents.events.length > 0
		) {
			const warnings = props.itemKeyEvents.events.filter(
				(keyEvent) => keyEvent.tag.toLowerCase() === "warning"
			)
			return warnings.length
		}
		return 0
	}
	const getUpdatesCount = (): number => {
		if (
			props.itemKeyEvents &&
			props.itemKeyEvents.events &&
			props.itemKeyEvents.events.length > 0
		) {
			const updates = props.itemKeyEvents.events.filter(
				(keyEvent) => keyEvent.tag.toLowerCase() === "update"
			)
			return updates.length
		}
		return 0
	}
	const onClickExpandButton = () => {
		setExpanded(!expanded)
		if (expanded === true) {
			props.updateExpandedPanel(props.lineItem.id)
		}
	}
	const getEvents = (): Event[] => {
		if (props.itemKeyEvents && props.itemKeyEvents.events) {
			return props.itemKeyEvents.events.map((keyEvent) => {
				return keyEvent.event
			})
		}
		return []
	}

	return (
		<div
			style={{
				borderRadius: "4px",
				border: "1px solid var(--divider, rgba(0, 0, 0, 0.12))",
				width: "100%",
				marginBottom: "14px",
			}}
		>
			<Grid
				container
				direction="row"
				spacing={2}
				justifyContent="space-between"
				alignItems="center"
				style={{padding: "0px 8px"}}
			>
				<Grid item xs={5}>
					<ItemDetails
						lineItem={props.lineItem}
						isOrderLegacy={props.isOrderLegacy}
						locale={props.locale}
					/>
				</Grid>
				<Grid item xs={2}>
					<KeyEventsStatistics warnings={getWarningsCount()} updates={getUpdatesCount()} />
				</Grid>
				<Grid item xs={5}>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "flex-end",
							gap: "68px",
						}}
					>
						<ItemTimeline
							itemStatus={getItemStatus(getEvents())}
							itemTimeLineDetails={getOrderItemTimeLine(getEvents(), props.orderCreationDate)}
							itemDeliveryDate={getItemDeliveryDate(getEvents(), props.lineItem.id)}
							keyEvents={props.itemKeyEvents}
						/>
						<Button color="primary" className={classes.expandButton} onClick={onClickExpandButton}>
							See all events
							<IconButton
								sx={{
									transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
									marginLeft: "auto",
									transition: (theme) =>
										theme.transitions.create("transform", {
											duration: theme.transitions.duration.shortest,
										}),
								}}
								color="primary"
								onClick={onClickExpandButton}
								aria-expanded={expanded}
								aria-label="Show more"
							>
								<ExpandMoreIcon />
							</IconButton>
						</Button>
					</div>
				</Grid>
			</Grid>
			<Collapse in={expanded} timeout="auto" unmountOnExit>
				<EventAccordionDetails events={props.itemKeyEvents?.events || []} />
			</Collapse>
		</div>
	)
}
